import { StyledInfoIcon } from './InfoIcon.styles';
import { Info } from '@mui/icons-material';
import React from 'react';

export interface Props {
  className?: string;
}

/**
 * Info icon.
 */
export const InfoIcon: React.FC<Props> = ({ className }) => {
  return (
    <StyledInfoIcon className={className}>
      <Info />
    </StyledInfoIcon>
  );
};
